var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileForm',_vm._b({on:{"form-submit":_vm.handleSubmit,"click":function($event){return _vm.$emit('click', $event)},"event":function($event){return _vm.$emit('event', $event)}}},'ProfileForm',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }